document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-lg-landing]").forEach((landing) => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const revealTargets = landing.querySelectorAll("[data-lg-reveal]");
    const scenes = Array.from(landing.querySelectorAll("[data-lg-cinematic-scene]"));
    const chapters = Array.from(landing.querySelectorAll("[data-lg-chapter]"));
    const chapterLinks = Array.from(landing.querySelectorAll("[data-lg-chapter-link]"));
    const intro = landing.querySelector("[data-lg-intro]");

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: 0.16 },
    );

    revealTargets.forEach((target) => revealObserver.observe(target));

    landing.querySelectorAll('a[href^="#lg-"]').forEach((link) => {
      link.addEventListener("click", (event) => {
        const target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
      });
    });

    const activeObserver = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        chapterLinks.forEach((link) => {
          const active = link.getAttribute("href") === `#${visible.target.id}`;
          link.classList.toggle("is-active", active);
          if (active) link.setAttribute("aria-current", "location");
          else link.removeAttribute("aria-current");
        });
      },
      { rootMargin: "-28% 0px -48% 0px", threshold: [0, 0.2, 0.5] },
    );

    chapters.forEach((chapter) => activeObserver.observe(chapter));

    if (reducedMotion) {
      intro?.classList.add("is-complete");
      landing.classList.add("lg-motion-reduced");
      return;
    }

    const introStartedAt = performance.now();
    document.body.classList.add("lg-intro-active");
    window.setTimeout(() => {
      landing.dataset.lgIntroClassAppliedMs = String(Math.round(performance.now() - introStartedAt));
      intro?.classList.add("is-complete");
      document.body.classList.remove("lg-intro-active");
    }, 1250);

    landing.classList.add("lg-motion-ready");
    let frame = 0;

    const render = () => {
      frame = 0;
      const viewportHeight = window.innerHeight;
      const pageDistance = Math.max(document.documentElement.scrollHeight - viewportHeight, 1);
      landing.style.setProperty("--lg-page-progress", Math.min(window.scrollY / pageDistance, 1).toFixed(4));

      scenes.forEach((scene) => {
        const rect = scene.getBoundingClientRect();
        const centerDelta = viewportHeight / 2 - (rect.top + rect.height / 2);
        const centered = Math.max(-1, Math.min(1, centerDelta / ((viewportHeight + rect.height) / 2)));
        const x = centered * 28;
        const y = centered * 44;

        scene.style.setProperty("--lg-scene-x", `${x.toFixed(2)}px`);
        scene.style.setProperty("--lg-scene-x-reverse", `${(-x).toFixed(2)}px`);
        scene.style.setProperty("--lg-scene-y", `${y.toFixed(2)}px`);
        scene.style.setProperty("--lg-copy-y", `${(-centered * 18).toFixed(2)}px`);
        scene.style.setProperty("--lg-scene-scale", (1.045 + Math.abs(centered) * 0.045).toFixed(4));
      });
    };

    const requestRender = () => {
      if (!frame) frame = window.requestAnimationFrame(render);
    };

    const onPointerMove = (event) => {
      const x = (event.clientX / window.innerWidth - 0.5) * 16;
      const y = (event.clientY / window.innerHeight - 0.5) * 12;
      landing.style.setProperty("--lg-pointer-x", `${x.toFixed(2)}px`);
      landing.style.setProperty("--lg-pointer-y", `${y.toFixed(2)}px`);
      landing.style.setProperty("--lg-pointer-x-reverse-soft", `${(-x * 0.35).toFixed(2)}px`);
      landing.style.setProperty("--lg-pointer-y-reverse-soft", `${(-y * 0.35).toFixed(2)}px`);
    };

    window.addEventListener("scroll", requestRender, { passive: true });
    window.addEventListener("resize", requestRender);
    window.addEventListener("pointermove", onPointerMove, { passive: true });
    render();
  });
});
